export default {
  pushDatalayer(event: number): void {
    let tagAtInternet = "";
    switch (event) {
      case 1: {
        tagAtInternet = "Fin du processus Chantier";
        break;
      }
      case 2: {
        tagAtInternet = "Fin du processus paramètres";
        break;
      }
      case 3: {
        tagAtInternet = "Fin du processus Mateiel";
        break;
      }
    }
    let dataLayer = [];

    dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "etools.interaction",
      etool_action: event,
      etool_name: "Outil Abaca",
      etool_step: tagAtInternet,
    });
  },
};
